import { cloneDeep } from 'lodash-es';
import SafeHtml from '~/vue_shared/directives/safe_html';
import NoteEditedText from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/components/note_edited_text.vue?vue3';
import { __ } from '~/locale';
import { getDraft } from '~/lib/utils/autosave';
import { renderGFM } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_gfm.js?vue3';
import { getAutosaveKey, getIdFromGid } from '../utils';
import WikiCommentForm from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/wiki_notes/components/wiki_comment_form.vue?vue3';
export default {
    name: 'NoteBody',
    directives: {
        SafeHtml
    },
    components: {
        NoteEditedText,
        WikiCommentForm
    },
    inject: [
        'noteableType'
    ],
    props: {
        note: {
            type: Object,
            required: true
        },
        noteableId: {
            type: String,
            required: true
        },
        canEdit: {
            type: Boolean,
            required: false,
            default: true
        },
        isEditing: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'cancel-edit',
        'creating-note-done',
        'creating-note-start',
        'creating-note-success'
    ],
    data () {
        return {
            updatedNote: cloneDeep(this.note)
        };
    },
    computed: {
        editedText () {
            return __('Edited');
        },
        noteId () {
            return getIdFromGid(this.note?.id);
        },
        hasDraft () {
            return getDraft(this.autosaveKey)?.trim();
        },
        autosaveKey () {
            return getAutosaveKey(this.noteableType, this.noteId);
        }
    },
    watch: {
        updatedNote: {
            async handler () {
                await this.$nextTick();
                this.renderGFM();
            },
            deep: true,
            immediate: true
        },
        isEditing (newVal) {
            if (Boolean(newVal) && !this.hasDraft) {
                this.$nextTick(()=>{
                    this.$refs.commentForm.note = this.updatedNote.body;
                });
            }
        }
    },
    methods: {
        updateNote (newNote) {
            this.updatedNote = newNote;
            this.$emit('creating-note-success');
        },
        renderGFM () {
            renderGFM(this.$refs['note-body']);
        }
    },
    safeHtmlConfig: {
        ADD_TAGS: [
            'use',
            'gl-emoji',
            'copy-code'
        ]
    }
};
